import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="discriptionbox-navigator">
            <div className="discriptionbox-nav-box">Description</div>
            <div className="discriptionbox-nav-box fade">Reviews (122)</div>
        </div>

        <div className="descriptionbox-description">
        <p>Experience unmatched comfort and style with this premium cotton shirt. 
         Perfect for casual outings or daily wear, lightweight and breathable. 
         Elevate your wardrobe with this essential fashion piece.</p>
         <p>

           Discover the perfect blend of style and comfort with this premium casual shirt. 
           Made from soft, breathable cotton, it ensures all-day comfort while keeping you stylish. 
           The modern design with subtle details makes it versatile for work, parties, or casual outings. 
            Durable stitching and high-quality fabric guarantee long-lasting wear. 
           Pair it effortlessly with jeans, chinos, or shorts to elevate your everyday wardrobe. 
          A must-have addition for anyone looking to combine fashion with practicality.
           </p>

        </div>
      
    </div>
  )
}

export default DescriptionBox

